"use strict";

/**
 * Google analytics
 */
(function () {
  // Call "onPageLoad" when page loaded and "Flix" object prepared
  document.addEventListener('flix:load', onPageLoad);
  var scriptLoaded = false;
  var gas = {
    tnaflix: {
      mobile: {
        organic: 'G-3Y9ZMHVSYE',
        mediabuy_merged: 'G-SG04DWH7L0'
      },
      web: {
        // organic: 'G-5H25B0EM1C', // temporarily, just to check stats
        organic: 'G-3Y9ZMHVSYE',
        mediabuy_merged: 'G-SG04DWH7L0'
      }
    },
    empflix: {
      mobile: {
        organic: 'G-T9HXHLBQ3M',
        mediabuy_merged: 'G-1EE8FDVCLJ'
      },
      web: {
        organic: 'G-ZEGXG1K0X3',
        mediabuy_merged: 'G-1EE8FDVCLJ'
      }
    }
  };
  var mediabuyGas = {
    tnaflix: {
      'alexz': 'G-6C7FEP482F',
      'tubecj': 'G-4T1PD153CT',
      'nudevista': 'G-7K1KBZ7X2C',
      'dimitry mature bitches': 'G-J91MLVKQ7W',
      'dc traffic': 'G-D3JR4P8QG5',
      'mediatrafficreports': 'G-0BTSTLNRCB',
      '1306': 'G-0BTSTLNRCB',
      '1305': 'G-ZBL3Q3GYML',
      'trafficshop': 'G-ZBL3Q3GYML',
      '1311': 'G-HHVJKR3YPJ',
      '1312': 'G-FNSHRZ5X77',
      'pbweb': 'G-K3P99W3KKL',
      '1366': 'G-5K46G8SV8C',
      'sci': 'G-R5TJ3XQKMM',
      '1354': 'G-6ZY0PQMK9V',
      'CS network': 'G-NK57XZBLGZ',
      'porn marathon': 'G-YDYQ973WP4',
      'hiddendoor mobile': 'G-M2XFWJ8W2S',
      'hiddendoor': 'G-M2XFWJ8W2S',
      'brokerbabe': 'G-GZVX09TV1J',
      'perlover': 'G-BSTS9ZS0XX',
      'conejox': 'G-W3P99MEMCK'
    },
    empflix: {
      'alexz': 'G-CV3WWM2X1L'
    }
  };

  /**
   * Do stuff on the page load
   */
  function onPageLoad() {
    // Add googletagmanager if it's not on the page yet
    if (!scriptLoaded) {
      scriptLoaded = true;
      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = 'https://www.googletagmanager.com/gtag/js';
      s.async = true;
      document.head.appendChild(s);
    }
    window.dataLayer = window.dataLayer || [];
    gtag('js', new Date());
    var device = FlixUtils.isMobile() ? 'mobile' : 'web';
    if (Flix.ads.isOrganic()) {
      // organic 
      gtag('config', gas[Flix.site][device]['organic']);
    } else {
      // "merged" 
      gtag('config', gas[Flix.site][device]['mediabuy_merged']);

      // Specific mediabuy, not just random utm_source
      if (Flix.ads.isSpecificBuy() && mediabuyGas[Flix.site][Flix.ads.utm_source]) {
        gtag('config', mediabuyGas[Flix.site][Flix.ads.utm_source]);
      }
    }
  }

  /**
   * GA4 function, but called within this module
   */
  function gtag() {
    dataLayer.push(arguments);
  }
})();